import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=0bbebbbb&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=0bbebbbb&prod&scoped=true&lang=css"
import style1 from "./Drawer.vue?vue&type=style&index=1&id=0bbebbbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbebbbb",
  null
  
)

export default component.exports